<div class="alert-sidebar" [ngClass]="isOpen ? 'open' : 'close'">
    <app-alert-sidebar-list [alerts]="alerts"></app-alert-sidebar-list>
</div>